export default {
  mock: {
    getUser: {
      cn: "梁123*",
      en: "梁1234",
      employeeNumber: "12345678",
      accessToken: "TV54364608324707328",
      deptPath: "美的_关联单位_IT外包资源管理_共享应用_MIP产品",
      address: "总部大楼",
      appKey: null,
      companyName: "美的_关联单位_IT外包资源管理_共享技术",
      companyNumber: "7871309237",
      createTime: 1540750093000,
      departmentName: "美的_关联单位_IT外包资源管理_共享应用_MIP产品",
      departmentNameEn: null,
      departmentNumber: "2933102332040192",
      departmentsPositions: null,
      deptId: 2933102332040192,
      deptList: [
        {
          appKey: null,
          code: "2933100550231040_2933100573660160_2933102265259008_2933102316868608_2933102332040192",
          departmentName: "美的_关联单位_IT外包资源管理_共享应用_MIP产品",
          departmentNameEn: null,
          departmentNumber: "2933102332040192",
          deptId: 2933102332040192,
          deptIdPath:
            "2933100550231040_2933100573660160_2933102265259008_2933102316868608_2933102332040192",
          displayId: null,
          displayName: null,
          displayNameEn: null,
          email: null,
          extras: null,
          hasSubDept: null,
          isRemoved: null,
          mucDeptNumber: null,
          ostyle: null,
          parentId: null,
          parentName: null,
          personIncharge: null,
          sourceId: null,
          sourceSyncTime: null,
          updateTime: 1586482546000,
        },
      ],
      displayId: null,
      empId: 1234567812345678,
      empStatus: 2,
      extras: null,
      gender: 0,
      idCard: null,
      isRemoved: false,
      leaveDate: null,
      mail: "xx.liang@midea.com",
      manager: null,
      mobile: "1244153556",
      mobileShort: "435666",
      mucUid: "ex_liangxx",
      password: null,
      photo:
        "http://mm.midea.com/group1/M00/04/22/ChAaYlsgeXOAGalHAAAwQ_D2-Zg649.jpg",
      photoSize: null,
      position: "XXJS0005700008",
      positionName: "IT外包开发工程师",
      positionNameEn: null,
      positionType: null,
      py: "liang123*",
      rank: "P",
      sourceId: "e1234567",
      sourceSyncTime: null,
      telephoneNumber: "8279-1234*",
      telephoneShort: "1241515",
      uid: "ex_lanlj2",
      updateTime: 1594193202000,
      userType: null,
      userId: "123435465768",
      userName: "梁123*",
      photoUrl:
        "http://mm.midea.com/group1/M00/04/22/ChAaYlsgeXOAGalHAAAwQ_D2-Zg649.jpg",
    },
  },
  // nativeApis: [
  //   // 获取当前应用的AppKey
  //   ["MideaCommon", "getAppKey"],
  //   // 获取用户头像
  //   ["Organization", "getAvatar"]
  // ]
};